import { createFileRoute, Navigate } from "@tanstack/react-router";

// No head() here: the home route inherits title/description/og/twitter from
// __root.tsx, and ships no og:image so serve-time hosting can inject the
// project's social preview (explicit og:image or latest screenshot).
export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Aleph Comex — Importação, exportação e comércio exterior" },
      { name: "description", content: "Inteligência em comércio exterior, importação, procurement, exportação e logística integrada desde 2010." },
      { property: "og:title", content: "Aleph Comex — Importação, exportação e comércio exterior" },
      { property: "og:description", content: "Inteligência em comércio exterior, importação, procurement, exportação e logística integrada desde 2010." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://alephcomex.com.br/pt" }],
  }),
  component: () => <Navigate to="/$lang" params={{ lang: "pt" }} replace />,
});
